"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OperationType = /** @class */ (function () {
    function OperationType() {
    }
    return OperationType;
}());
exports.OperationType = OperationType;
var TransferPrototype = /** @class */ (function () {
    function TransferPrototype() {
    }
    TransferPrototype.getPrototype = function () {
        return {
            from: '1.2.X',
            to: '1.2.X',
            amount: { amount: 10, asset_id: '1.3.0' },
            memo: { from: '', to: '', nonce: '', message: '' },
        };
    };
    return TransferPrototype;
}());
exports.TransferPrototype = TransferPrototype;
var ContentCancelPrototype = /** @class */ (function () {
    function ContentCancelPrototype() {
    }
    ContentCancelPrototype.getPrototype = function () {
        return {
            author: '1.2.X',
            URI: '',
        };
    };
    return ContentCancelPrototype;
}());
exports.ContentCancelPrototype = ContentCancelPrototype;
var BuyContentPrototype = /** @class */ (function () {
    function BuyContentPrototype() {
    }
    BuyContentPrototype.getPrototype = function () {
        return {
            URI: '',
            consumer: '1.2.X',
            price: {
                amount: 0,
                asset_id: '1.3.0',
            },
            region_code_from: 0,
            pubKey: {
                s: '',
            },
        };
    };
    return BuyContentPrototype;
}());
exports.BuyContentPrototype = BuyContentPrototype;
var SubmitContentPrototype = /** @class */ (function () {
    function SubmitContentPrototype() {
    }
    SubmitContentPrototype.getPrototype = function () {
        return {
            size: 1024,
            author: '1.2.X',
            co_authors: ['1.2.X', '1.2.X'],
            URI: '',
            quorum: 0,
            price: [{
                    region: 0,
                    price: {
                        amount: 10,
                        asset_id: '1.3.0'
                    }
                }],
            hash: '',
            seeders: ['1.2.X', '1.2.X'],
            key_parts: [
                { C1: { s: '' }, D1: { s: '' } },
            ],
            expiration: '2018-07-04T16:00:00',
            publishing_fee: {
                amount: 0,
                asset_id: '1.3.0',
            },
            synopsis: ''
        };
    };
    return SubmitContentPrototype;
}());
exports.SubmitContentPrototype = SubmitContentPrototype;
var UpdateAccountPrototype = /** @class */ (function () {
    function UpdateAccountPrototype() {
    }
    UpdateAccountPrototype.getPrototype = function () {
        return {
            account: '1.2.X',
            owner: {
                weight_threshold: 0,
                account_auths: [],
                key_auths: [['', 0], ['', 1]],
            },
            active: {
                weight_threshold: 0,
                account_auths: [],
                key_auths: [['', 0], ['', 1]],
            },
            new_options: {
                memo_key: '',
                voting_account: '',
                num_miner: 0,
                votes: ['', ''],
                extensions: [],
                allow_subscription: true,
                price_per_subscribe: {
                    amount: 0,
                    asset_id: '1.3.0',
                },
                subscription_period: 0,
            },
            extensions: [],
        };
    };
    return UpdateAccountPrototype;
}());
exports.UpdateAccountPrototype = UpdateAccountPrototype;
var AssetCreatePrototype = /** @class */ (function () {
    function AssetCreatePrototype() {
    }
    AssetCreatePrototype.getPrototype = function () {
        return {
            issuer: '1.2.X',
            symbol: '',
            precision: 0,
            description: '',
            options: {
                max_supply: 0,
                core_exchange_rate: {
                    base: {
                        amount: 0,
                        asset_id: '1.3.0',
                    },
                    quote: {
                        amount: 0,
                        asset_id: '1.3.0',
                    },
                },
                is_exchangeable: false,
                extensions: [],
            },
            is_exchangeable: false,
            extensions: [],
            monitored_asset_opts: {
                feeds: [],
                current_feed: {
                    core_exchange_rate: {
                        base: {
                            amount: 0,
                            asset_id: '1.3.0',
                        },
                        quote: {
                            amount: 0,
                            asset_id: '1.3.0',
                        },
                    },
                },
                current_feed_publication_time: 0,
                feed_lifetime_sec: 0,
                minimum_feeds: 0,
            },
        };
    };
    return AssetCreatePrototype;
}());
exports.AssetCreatePrototype = AssetCreatePrototype;
var IssueAssetPrototype = /** @class */ (function () {
    function IssueAssetPrototype() {
    }
    IssueAssetPrototype.getPrototype = function () {
        return {
            issuer: '1.2.X',
            asset_to_issue: {
                amount: 0,
                asset_id: '1.3.0',
            },
            issue_to_account: '1.2.X',
            memo: {
                from: '',
                to: '',
                nonce: '',
                message: '',
            },
            extensions: {}
        };
    };
    return IssueAssetPrototype;
}());
exports.IssueAssetPrototype = IssueAssetPrototype;
var UpdateUserIssuedAssetPrototype = /** @class */ (function () {
    function UpdateUserIssuedAssetPrototype() {
    }
    UpdateUserIssuedAssetPrototype.getPrototype = function () {
        return {
            issuer: '1.2.X',
            asset_to_update: '1.3.X',
            new_description: '',
            max_supply: 0,
            core_exchange_rate: {
                base: {
                    amount: 0,
                    asset_id: '1.3.0',
                },
                quote: {
                    amount: 0,
                    asset_id: '1.3.0',
                },
            },
            is_exchangeable: true,
            new_issuer: '1.2.X',
            extensions: {},
        };
    };
    return UpdateUserIssuedAssetPrototype;
}());
exports.UpdateUserIssuedAssetPrototype = UpdateUserIssuedAssetPrototype;
var AssetFundPoolsPrototype = /** @class */ (function () {
    function AssetFundPoolsPrototype() {
    }
    AssetFundPoolsPrototype.getPrototype = function () {
        return {
            from_account: '1.2.X',
            uia_asset: {
                amount: 0,
                asset_id: '1.3.0',
            },
            dct_asset: {
                amount: 0,
                asset_id: '1.3.0',
            }
        };
    };
    return AssetFundPoolsPrototype;
}());
exports.AssetFundPoolsPrototype = AssetFundPoolsPrototype;
var AssetReservePrototype = /** @class */ (function () {
    function AssetReservePrototype() {
    }
    AssetReservePrototype.getPrototype = function () {
        return {
            payer: '1.2.X',
            amount_to_reserve: {
                amount: 0,
                asset_id: '1.3.0',
            },
            extensions: {}
        };
    };
    return AssetReservePrototype;
}());
exports.AssetReservePrototype = AssetReservePrototype;
var AssetClaimFeesPrototype = /** @class */ (function () {
    function AssetClaimFeesPrototype() {
    }
    AssetClaimFeesPrototype.getPrototype = function () {
        return {
            issuer: '1.2.X',
            uia_asset: {
                amount: 0,
                asset_id: '1.3.0',
            },
            dct_asset: {
                amount: 0,
                asset_id: '1.3.0',
            },
            extensions: {}
        };
    };
    return AssetClaimFeesPrototype;
}());
exports.AssetClaimFeesPrototype = AssetClaimFeesPrototype;
var LeaveRatingAndCommentPrototype = /** @class */ (function () {
    function LeaveRatingAndCommentPrototype() {
    }
    LeaveRatingAndCommentPrototype.getPrototype = function () {
        return {
            URI: '',
            consumer: '1.2.X',
            comment: '',
            rating: 0,
        };
    };
    return LeaveRatingAndCommentPrototype;
}());
exports.LeaveRatingAndCommentPrototype = LeaveRatingAndCommentPrototype;
var AssetPublishFeedPrototype = /** @class */ (function () {
    function AssetPublishFeedPrototype() {
    }
    AssetPublishFeedPrototype.getPrototype = function () {
        return {
            publisher: '1.2.X',
            asset_id: '1.3.X',
            feed: {
                core_exchange_rate: {
                    base: {
                        amount: 0,
                        asset_id: '1.3.0',
                    },
                    quote: {
                        amount: 0,
                        asset_id: '1.3.0',
                    },
                }
            },
            extensions: {}
        };
    };
    return AssetPublishFeedPrototype;
}());
exports.AssetPublishFeedPrototype = AssetPublishFeedPrototype;
var MinerCreatePrototype = /** @class */ (function () {
    function MinerCreatePrototype() {
    }
    MinerCreatePrototype.getPrototype = function () {
        return {
            miner_account: '1.2.X',
            url: '',
            block_signing_key: '',
        };
    };
    return MinerCreatePrototype;
}());
exports.MinerCreatePrototype = MinerCreatePrototype;
var MinerUpdatePrototype = /** @class */ (function () {
    function MinerUpdatePrototype() {
    }
    MinerUpdatePrototype.getPrototype = function () {
        return {
            miner: '1.2.X',
            miner_account: '',
            new_url: '',
            new_signing_key: '',
        };
    };
    return MinerUpdatePrototype;
}());
exports.MinerUpdatePrototype = MinerUpdatePrototype;
var MinerUpdateGlobalParametersPrototype = /** @class */ (function () {
    function MinerUpdateGlobalParametersPrototype() {
    }
    MinerUpdateGlobalParametersPrototype.getPrototype = function () {
        return {
            new_parameters: {
                current_fees: {
                    parameters: [[0, {}]],
                    scale: 0,
                },
                block_interval: 0,
                maintenance_interval: 0,
                maintenance_skip_slots: 0,
                miner_proposal_review_period: 0,
                maximum_transaction_size: 0,
                maximum_block_size: 0,
                maximum_time_until_expiration: 0,
                maximum_proposal_lifetime: 0,
                maximum_asset_feed_publishers: 0,
                maximum_miner_count: 0,
                maximum_authority_membership: 0,
                cashback_vesting_period_seconds: 0,
                cashback_vesting_threshold: 0,
                max_predicate_opcode: 0,
                max_authority_depth: 0,
                extensions: [],
            }
        };
    };
    return MinerUpdateGlobalParametersPrototype;
}());
exports.MinerUpdateGlobalParametersPrototype = MinerUpdateGlobalParametersPrototype;
var ProposalCreatePrototype = /** @class */ (function () {
    function ProposalCreatePrototype() {
    }
    ProposalCreatePrototype.getPrototype = function () {
        return {
            fee_paying_account: '1.2.X',
            proposed_ops: [{}],
            expiration_time: '2018-07-04T16:00:00',
            review_period_seconds: 0,
            extensions: []
        };
    };
    return ProposalCreatePrototype;
}());
exports.ProposalCreatePrototype = ProposalCreatePrototype;
var ProposalUpdatePrototype = /** @class */ (function () {
    function ProposalUpdatePrototype() {
    }
    ProposalUpdatePrototype.getPrototype = function () {
        return {
            fee_paying_account: '1.2.X',
            proposal: '1.6.X',
            active_approvals_to_add: ['', ''],
            active_approvals_to_remove: ['', ''],
            owner_approvals_to_add: ['', ''],
            owner_approvals_to_remove: ['', ''],
            key_approvals_to_add: ['', ''],
            key_approvals_to_remove: ['', ''],
            extensions: []
        };
    };
    return ProposalUpdatePrototype;
}());
exports.ProposalUpdatePrototype = ProposalUpdatePrototype;
var OperationWrapperPrototype = /** @class */ (function () {
    function OperationWrapperPrototype() {
    }
    OperationWrapperPrototype.getPrototype = function () {
        return {
            op: {},
        };
    };
    return OperationWrapperPrototype;
}());
exports.OperationWrapperPrototype = OperationWrapperPrototype;
var CreateAccountPrototype = /** @class */ (function () {
    function CreateAccountPrototype() {
    }
    CreateAccountPrototype.getPrototype = function () {
        return {
            fee: {
                amount: 0,
                asset_id: '1.3.0'
            },
            name: '',
            owner: {
                weight_threshold: 0,
                account_auths: [],
                key_auths: [['', 0]],
            },
            active: {
                weight_threshold: 0,
                account_auths: [],
                key_auths: [['', 0]],
            },
            options: {
                memo_key: '',
                voting_account: '',
                num_miner: 0,
                votes: [],
                extensions: [],
                allow_subscription: true,
                price_per_subscribe: {
                    amount: 0,
                    asset_id: '1.3.0',
                },
                subscription_period: 0,
            },
            registrar: '',
            extensions: [],
        };
    };
    return CreateAccountPrototype;
}());
exports.CreateAccountPrototype = CreateAccountPrototype;
var VestingBalanceWithdrawPrototype = /** @class */ (function () {
    function VestingBalanceWithdrawPrototype() {
    }
    VestingBalanceWithdrawPrototype.getPrototype = function () {
        return {
            vesting_balance: '',
            owner: '1.2.X',
            amount: {
                amount: 0,
                asset_id: '1.3.0',
            }
        };
    };
    return VestingBalanceWithdrawPrototype;
}());
exports.VestingBalanceWithdrawPrototype = VestingBalanceWithdrawPrototype;
var UpdateMonitoredAssetPrototype = /** @class */ (function () {
    function UpdateMonitoredAssetPrototype() {
    }
    UpdateMonitoredAssetPrototype.getPrototype = function () {
        return {
            issuer: '1.2.X',
            asset_to_update: '1.3.X',
            new_description: '',
            new_feed_lifetime_sec: 0,
            new_minimum_feeds: 1,
        };
    };
    return UpdateMonitoredAssetPrototype;
}());
exports.UpdateMonitoredAssetPrototype = UpdateMonitoredAssetPrototype;
var SubscribePrototype = /** @class */ (function () {
    function SubscribePrototype() {
    }
    SubscribePrototype.getPrototype = function () {
        return {
            from: '1.2.X',
            to: '1.2.X',
            price: {
                amount: 0,
                asset_id: '1.3.0'
            }
        };
    };
    return SubscribePrototype;
}());
exports.SubscribePrototype = SubscribePrototype;
var SubscribeByAuthorPrototype = /** @class */ (function () {
    function SubscribeByAuthorPrototype() {
    }
    SubscribeByAuthorPrototype.getPrototype = function () {
        return {
            from: '1.2.X',
            to: '1.2.X',
        };
    };
    return SubscribeByAuthorPrototype;
}());
exports.SubscribeByAuthorPrototype = SubscribeByAuthorPrototype;
var SetAutomaticRenewalOfSubscriptionPrototype = /** @class */ (function () {
    function SetAutomaticRenewalOfSubscriptionPrototype() {
    }
    SetAutomaticRenewalOfSubscriptionPrototype.getPrototype = function () {
        return {
            consumer: '1.2.X',
            subscription: '2.15.X',
            automatic_renewal: true,
        };
    };
    return SetAutomaticRenewalOfSubscriptionPrototype;
}());
exports.SetAutomaticRenewalOfSubscriptionPrototype = SetAutomaticRenewalOfSubscriptionPrototype;
//# sourceMappingURL=operationPrototype.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/model/operationPrototype.js
// module id = 326
// module chunks = 0